import React, { FC, useEffect, useState } from 'react'
import cn from 'classnames'
import { User } from '@components/icons'
import { useAuthUI, useAccount } from '@corratech/pylot-auth-manager'
import { Button } from '@corratech/pylot-ui'
import DropdownMenu from 'stores/ooka_default/components/common/UserNav/DropdownMenu'
import AddToCartIcon from 'stores/ooka_default/components/addToCartIcon/AddToCartIcon'
import { useTranslation } from 'react-i18next'
import { ClickOutside } from '@corratech/pylot-utils'
// @ts-ignore
import s from '@components/common/UserNav/UserNav.module.scss'
import { useAlfakherContext } from '@components/alfakherContext/AlfakherContext'
import StoreSwitcher from 'stores/ooka_uae_store/components/common/StoreSwitcher/StoreSwitcher'

interface Props {
    className?: string
    setSearchOpened: () => void
}

export const UserNav: FC<Props> = ({ className }) => {
    const { t } = useTranslation()
    const { data } = useAccount()
    const [displayLanguageDropdown, setDisplayLanguageDropdown] = useState(
        false
    )
    const {
        setToggleReinitYotpoReviewPageWidget,
        toggleYotpoReviewPageWidget
    } = useAlfakherContext()
    const { openAuthModal } = useAuthUI()

    useEffect(() => {
        setToggleReinitYotpoReviewPageWidget(!toggleYotpoReviewPageWidget)
    }, [data?.data?.customer?.firstname])

    const isTokenExist =
        typeof window !== 'undefined' &&
        window.localStorage.getItem('pylot_token')
    return (
        <nav className={cn(s.root, className)}>
            <ul className={s.list}>
                <ClickOutside
                    active={displayLanguageDropdown}
                    onClick={() => setDisplayLanguageDropdown(false)}
                >
                    <li className={cn(s.item, s['language-dropdown-wrapper'])}>
                        <StoreSwitcher footerSwitcher={false} />
                    </li>
                </ClickOutside>
                <li className={cn(s['user-menu'], s.item)}>
                    {isTokenExist ? (
                        <DropdownMenu />
                    ) : (
                        <Button
                            className={s.avatarButton}
                            variant="link"
                            onClick={() => openAuthModal()}
                            aria-label={t('Menu')}
                        >
                            <User />
                        </Button>
                    )}
                </li>
                <li className={s.item}>
                    <AddToCartIcon isOpen cartStyle={s['cart-count']} />
                </li>
            </ul>
        </nav>
    )
}

export default UserNav
